export default __webpack_public_path__ + "static/depth-1b577ba0e65008ae1b4182f1067c7e77.png";